import { precogCounterConstants } from "../../../actions/precog/counter";

const defaultState = {
  status: {
    started: false,    
    error: false,
    ended: false
  },
  data: null
};

export function counter(state = defaultState, { type, payload, error }) {
  switch (type) {
  case precogCounterConstants.CLEAR_PRECOG_COUNTER:
    return defaultState;
  case precogCounterConstants.GET_PRECOG_COUNTER_START:
    return {
      ...state,
      status: {
        started: true,        
        error: false,
        ended: false
      }
    }; 
  case precogCounterConstants.GET_PRECOG_COUNTER_SUCCESS:
    return {
      ...state,
      status: {
        started: false,        
        error: false,
        ended: true
      },
      data: payload
    }; 
  case precogCounterConstants.GET_PRECOG_COUNTER_ERROR:
    return {
      ...state,
      status: {
        started: false,        
        error: true,
        ended: true
      }
    };
  default:
    return state;
  }
}
